var render = function render(){var _vm=this,_c=_vm._self._c;return _c('format',{attrs:{"msg":_vm.$t('online-slot'),"type-game":4,"src":require('@/assets/nav/submenu/icon_submenu15.svg')}})
}
var staticRenderFns = []

export { render, staticRenderFns }